module.exports = __webpack_public_path__ + "static/img/product-19.36d7de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-19.png
// module id = +RNq
// module chunks = 0